import useApi from "storybook-dashboard/utils/fetching";
import Im from "immutable";

export const useTerm = (term) => {
  let { data } = useApi("/api/tenant/meta/");
  let term_map = (data || Im.Map()).get("term_map") || Im.Map();
  return term_map.get(term) || term;
};
